import React from "react";
import { ReactSVG } from "react-svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Progress from "react-svg-progress";

const IconButton = ({ className, icon, title, tooltipPlacement, loading, disabled, onClick }) => {
  return (
    <OverlayTrigger
      placement={tooltipPlacement || "left"}
      overlay={
        <Tooltip id="button-tooltip">{title}</Tooltip>
      }
    >
      <button
        className={`${className} icon-button`}
        disabled={loading || disabled}
        onClick={onClick}
      >
        {loading ? (
          <Progress color="#265F78" size="15px" />
        ) : (
          <ReactSVG className="icon" src={icon} />
        )}
      </button>
    </OverlayTrigger>
  );
}

export default IconButton;
